import React, { useEffect, useState } from 'react'
import Introduction from './common/Introduction'
import ResourceResumes from './manualChoice/ResourceResumes'
import FeedbacksContainer from './common/FeedbacksContainer'
import Footer from './common/Footer'


const ManualChoiceResults = ({ session, instances, results, feedbacks }) => {
    
    const [playedTimes, setPlayedTimes] = useState('')
    
    //Ce state est utilisé pour stocker le nom du participant sélectionné dans le menu déroulant de Introduction.js
    const [selectedName, setSelectedName] = useState(null);

    useEffect(() => {
        let totalPlayedTimes = 0
        results[0].results.forEach((res, i) => {
            totalPlayedTimes = totalPlayedTimes + res.points
            if (i === results[0].results.length - 1) {
                setPlayedTimes(totalPlayedTimes)
            }
        })
    })

    return (
        <div className='new-results'>
            <Introduction
                session={session}
                protocol={'Manual choice'}
                playedTimes={playedTimes}
                onSelectName={setSelectedName} 
                results={results}
            />
            <ResourceResumes
                results={results}
                playedTimes={playedTimes}
                selectedName={selectedName}
            />
            {(feedbacks && feedbacks.length) ?
                <FeedbacksContainer
                    feedbacks={feedbacks}
                    selectedName={selectedName}
                />
                :
                <></>
            }
            <Footer />
        </div>
    )
}

export default ManualChoiceResults